import { useRef } from 'react'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { openFeedbackForm } from '../../../Services/Telemetry/Feedback.js'
import { useModal } from '../../Modal/UseModal.js'
import { TooltipTrigger } from '../../../Provider/TooltipManager.tsx'

/**
 * The `?` in the top bar. "Report a Bug" used to live only among the footer's link list, which is
 * where nobody looks when something has just gone wrong.
 */
export const HelpMenu = () => {
  const { openModal } = useModal()
  const menu = useRef<HTMLDetailsElement>(null)

  const run = (action: () => void) => () => {
    menu.current?.removeAttribute('open')
    action()
  }

  return (
    <details ref={menu} data-testid="help-menu" className="dropdown dropdown-end z-50">
      <summary role="button" aria-label="Help" className="btn btn-ghost btn-circle">
        <TooltipTrigger tooltip="Help, news and feedback">
          <QuestionMarkCircleIcon className="w-6 h-6" />
        </TooltipTrigger>
      </summary>
      <ul className="dropdown-content menu absolute right-0 z-10 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5">
        <li>
          <Link to="/news" data-testid="help-news" onClick={run(() => {})} className="block px-4 py-2 text-sm text-gray-700">
            News
          </Link>
        </li>
        <li>
          <a href="#" data-testid="help-report-bug" onClick={run(() => void openFeedbackForm())} className="block px-4 py-2 text-sm text-gray-700">
            Report a Bug
          </a>
        </li>
        <li>
          <a
            href="#"
            data-testid="help-system-news"
            onClick={run(() => openModal('systemNotifications', {}))}
            className="block px-4 py-2 text-sm text-gray-700"
          >
            System news
          </a>
        </li>
        <li>
          <a href="#" data-testid="help-changelog" onClick={run(() => openModal('changelog', {}))} className="block px-4 py-2 text-sm text-gray-700">
            Changelog
          </a>
        </li>
      </ul>
    </details>
  )
}
